export default "__VITE_ASSET__e0c2faac__"